module.exports = __webpack_public_path__ + "assets/img/15128be10514eedc9e16cc14880d3b9c.png";